var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3"},[_c('div',{staticClass:"d-flex flex-row justify-space-between"},[_c('div',{staticClass:"sl-title"},[_vm._v("My Shop")]),_c('AddBtn')],1),_c('v-divider',{staticClass:"my-2"}),_c('Groups'),_c('Form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }